import API from '../../../constants/api';
import { addSeekDirectionAndParamsToUrlParams } from '../../../constants/UrlUtil';

export const FETCH_COST_ACCOUNTING_PERIODS_REQUEST = '@@costAccounting/FETCH_PERIODS_REQUEST';
export const FETCH_COST_ACCOUNTING_PERIODS_SUCCESS = '@@costAccounting/FETCH_PERIODS_SUCCESS';
export const FETCH_COST_ACCOUNTING_PERIODS_FAILURE = '@@costAccounting/FETCH_PERIODS_FAILURE';

export const FETCH_COST_ACCOUNTING_ENTRIES_REQUEST = '@@costAccounting/FETCH_ENTRIES_REQUEST';
export const FETCH_COST_ACCOUNTING_ENTRIES_SUCCESS = '@@costAccounting/FETCH_ENTRIES_SUCCESS';
export const FETCH_COST_ACCOUNTING_ENTRIES_FAILURE = '@@costAccounting/FETCH_ENTRIES_FAILURE';

export const FETCH_COST_ACCOUNTING_AUDIT_REQUEST = '@@costAccounting/FETCH_AUDIT_REQUEST';
export const FETCH_COST_ACCOUNTING_AUDIT_SUCCESS = '@@costAccounting/FETCH_AUDIT_SUCCESS';
export const FETCH_COST_ACCOUNTING_AUDIT_FAILURE = '@@costAccounting/FETCH_AUDIT_FAILURE';

export const FETCH_COST_ACCOUNTING_PROFITABILITY_REQUEST = '@@costAccounting/FETCH_PROFITABILITY_REQUEST';
export const FETCH_COST_ACCOUNTING_PROFITABILITY_SUCCESS = '@@costAccounting/FETCH_PROFITABILITY_SUCCESS';
export const FETCH_COST_ACCOUNTING_PROFITABILITY_FAILURE = '@@costAccounting/FETCH_PROFITABILITY_FAILURE';

export const COST_ACCOUNTING_ACTION_REQUEST = '@@costAccounting/ACTION_REQUEST';
export const COST_ACCOUNTING_ACTION_SUCCESS = '@@costAccounting/ACTION_SUCCESS';
export const COST_ACCOUNTING_ACTION_FAILURE = '@@costAccounting/ACTION_FAILURE';

export const fetchCostAccountingPeriods = (
    page = 0,
    size = 200,
    seekParams,
    seekDirection = 'FORWARD',
) => {
    let api = `${API.COST_ACCOUNTING.PERIODS}?size=${size}`;
    api = addSeekDirectionAndParamsToUrlParams(api, seekDirection, seekParams);
    return {
        type: FETCH_COST_ACCOUNTING_PERIODS_REQUEST,
        api,
        page,
        size,
    };
};

export const fetchCostAccountingEntries = (
    periodUuid,
    state = 'DRAFT',
    page = 0,
    size = 20,
    sourceType,
    sourceId,
    seekParams,
    seekDirection = 'FORWARD',
) => {
    let api = `${API.COST_ACCOUNTING.ENTRIES}?periodUuid=${periodUuid}&state=${state}&size=${size}`;
    if (sourceType) {
        api += `&sourceType=${encodeURIComponent(sourceType)}`;
    }
    if (sourceId) {
        api += `&sourceId=${encodeURIComponent(sourceId)}`;
    }
    api = addSeekDirectionAndParamsToUrlParams(api, seekDirection, seekParams);
    return {
        type: FETCH_COST_ACCOUNTING_ENTRIES_REQUEST,
        api,
        periodUuid,
        state,
        sourceType: sourceType || '',
        sourceId: sourceId || '',
        page,
        size,
    };
};

export const fetchCostAccountingAudit = ({
    periodUuid,
    entryUuid,
    sourceType,
    sourceId,
    page = 0,
    size = 20,
    seekParams,
    seekDirection = 'FORWARD',
}) => {
    const params = new URLSearchParams({ size: String(size) });
    if (periodUuid) params.set('periodUuid', periodUuid);
    if (entryUuid) params.set('entryUuid', entryUuid);
    if (sourceType) params.set('sourceType', sourceType);
    if (sourceId) params.set('sourceId', sourceId);
    let api = `${API.COST_ACCOUNTING.AUDIT}?${params.toString()}`;
    api = addSeekDirectionAndParamsToUrlParams(api, seekDirection, seekParams);
    return {
        type: FETCH_COST_ACCOUNTING_AUDIT_REQUEST,
        api,
        page,
        size,
        auditFetchKey: `${periodUuid || ''}:${entryUuid || ''}:${sourceType || ''}:${sourceId || ''}:${page}`,
    };
};

export const fetchCostAccountingProfitability = (periodUuid, projectionType) => {
    const params = new URLSearchParams({ periodUuid });
    if (projectionType === 'CONSOLIDATED') {
        params.append('consolidated', 'true');
    } else if (projectionType === 'BY_PROJECTION') {
        params.append('allProjections', 'true');
    } else {
        params.append('projectionType', projectionType);
    }
    return {
        type: FETCH_COST_ACCOUNTING_PROFITABILITY_REQUEST,
        api: `${API.COST_ACCOUNTING.PROFITABILITY}?${params.toString()}`,
        projectionType,
    };
};

export const costAccountingAction = (api, payload, successCallback, failureCallBack, method = 'post') => ({
    type: COST_ACCOUNTING_ACTION_REQUEST,
    api,
    payload,
    method,
    successCallback,
    failureCallBack,
});
